export default __webpack_public_path__ + "static/media/higiene.1da575dd.jpg";